import { STORE_INFO } from '@/mocks/content';

const FOOTER_LINKS = [
  { label: 'コンセプト', href: '#concept' },
  { label: '店内ツアー', href: '#interior' },
  { label: '料金案内', href: '#pricing' },
  { label: '系列店', href: '#sister' },
  { label: 'アクセス', href: '#access' },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#060608] border-t border-[#C9A84C]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Brand */}
          <div>
            <p
              className="text-[#C9A84C] text-xs tracking-[0.4em] mb-1"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              {STORE_INFO.nameEn}
            </p>
            <h3
              className="text-white text-2xl font-bold tracking-widest mb-4"
              style={{ fontFamily: "'Shippori Mincho', serif" }}
            >
              {STORE_INFO.name}
            </h3>
            <p
              className="text-white/40 text-xs leading-[2] tracking-widest"
              style={{ fontFamily: "'Shippori Mincho', serif" }}
            >
              大人の時間が、静かに流れる場所。<br />
              富山市総曲輪にて、皆様のお越しを<br />
              心よりお待ちしております。
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p
              className="text-[#C9A84C]/70 text-xs tracking-[0.4em] mb-5 pb-3 border-b border-[#C9A84C]/20"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              NAVIGATION
            </p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleClick(link.href)}
                    className="text-white/50 text-xs tracking-widest hover:text-[#C9A84C] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: "'Shippori Mincho', serif" }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-[#C9A84C]/70 text-xs tracking-[0.4em] mb-5 pb-3 border-b border-[#C9A84C]/20"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              CONTACT
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-[#C9A84C]/60 text-sm" />
                </div>
                <p
                  className="text-white/50 text-xs tracking-widest leading-[1.8]"
                  style={{ fontFamily: "'Shippori Mincho', serif" }}
                >
                  {STORE_INFO.address}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-[#C9A84C]/60 text-sm" />
                </div>
                <p
                  className="text-white/50 text-xs tracking-widest"
                  style={{ fontFamily: "'Shippori Mincho', serif" }}
                >
                  {STORE_INFO.hours}
                </p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a
                  href={STORE_INFO.instagram}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/30 text-[#C9A84C]/60 hover:text-[#C9A84C] hover:border-[#C9A84C]/60 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-line text-sm" />
                </a>
              </div>
            </div>
          </div>
          </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-[#C9A84C]/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p
            className="text-white/20 text-xs tracking-widest"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            &copy; {new Date().getFullYear()} {STORE_INFO.name}. All rights reserved.
          </p>
          <p
            className="text-white/20 text-xs tracking-widest"
            style={{ fontFamily: "'Shippori Mincho', serif" }}
          >
            富山市総曲輪 センタービル3階
          </p>
        </div>
      </div>
    </footer>
  );
}
